import React from "react";
import { useSearchParams } from "react-router-dom";
import Landing from "../pages/Landing";
import CustomerPortal from "./customer/CustomerPortal";

/**
 * Smart Landing Component
 * Detects if the request is from a customer subdomain (e.g., neostore.aftersales.pro)
 * and shows the appropriate page:
 * - Customer subdomain → Customer Portal
 * - Main domain (aftersales.pro) → Marketing Landing Page
 */
export default function SmartLanding() {
  const [searchParams] = useSearchParams();
  
  // Check if there's a shop query param (for testing)
  const shopParam = searchParams.get("shop");
  if (shopParam) {
    return <CustomerPortal />;
  }
  
  // Check subdomain from hostname
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  
  // Detect customer subdomain patterns:
  // - xxx.aftersales.pro (production)
  // - xxx.preview.emergentagent.com (preview - but this has 4 parts)
  // - localhost or IP (development)
  
  const isLocalhost = hostname === "localhost" || hostname.match(/^\d+\.\d+\.\d+\.\d+$/);
  const isMainDomain = hostname === "aftersales.pro" || hostname === "www.aftersales.pro";
  const isPreviewMain = hostname.endsWith("preview.emergentagent.com") && parts.length <= 3;
  
  // If it's not the main domain, localhost, or preview main, it's likely a customer subdomain
  if (!isLocalhost && !isMainDomain && !isPreviewMain) {
    // Check if first part looks like a valid shop subdomain (not "www", "api", etc.)
    const firstPart = parts[0];
    const reservedSubdomains = ["www", "api", "admin", "app", "mail", "ftp", "staging", "dev"];
    
    if (!reservedSubdomains.includes(firstPart.toLowerCase())) {
      return <CustomerPortal />;
    }
  }
  
  // Default to marketing landing page
  return <Landing />;
}
